(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["coverage-diagram"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hsc-coverage-diagram')) {
    const HSC_CD_FALLBACK = { 'sky-blue': '#8399B2', sand: '#DCC5AC', blush: '#E6C1BC' };
    class HscCoverageDiagram extends HTMLElement {
      connectedCallback() {
        this.onVariant = (event) => this.update(event.detail);
        document.addEventListener('hsc:variant:change', this.onVariant);
      }
      disconnectedCallback() {
        document.removeEventListener('hsc:variant:change', this.onVariant);
      }
      update(detail) {
        const variant = detail && detail.variant;
        if (!variant) return;
        const pid = this.dataset.productId;
        if (pid && detail.productId && String(detail.productId) !== pid) return;
        const handle = String(variant.color_handle || '').replace(/[^a-z0-9-]/g, '');
        let fill = '';
        if (/^#[0-9a-f]{3,8}$/i.test(variant.swatch || '')) fill = variant.swatch;
        else if (handle) fill = `var(--sw-${handle}, ${HSC_CD_FALLBACK[handle] || '#7C9CB8'})`;
        if (!fill) return;
        this.querySelectorAll('.coverage-diagram__relaxed').forEach((el) => { el.style.fill = fill; });
        this.querySelectorAll('.coverage-diagram__swatch').forEach((el) => { el.style.background = fill; });
      }
    }
    customElements.define('hsc-coverage-diagram', HscCoverageDiagram);
  }
  } catch(e) { console.error(e); }
})();

})();
